
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import './assets/styles/_md.scss'
import './assets/styles/_sm.scss'
import './assets/styles/_small.scss'
import './assets/styles/_xl.scss'
import './assets/styles/_xs.scss'
import './assets/styles/_lg.scss'
import './assets/styles/style.scss'
import './assets/styles/styles.scss'
import Main from './Main'
import NotFound from './NotFound'

function App() {

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/football">
          <Main />
        </Route>
        <Route path="*" component={NotFound} />
      </Switch>
    </BrowserRouter>
  )
}

export default App
